export const contactsData = {
    email: 'muasab.sabir@gmail.com',
    phone: '+92 318 1630 810',
    address: 'Ashiana Housing Society, Burewala, Pakistan - 61010 ',

    sheetAPI: ''
}